<!-- Navigation -->
<zuper-vertical-navigation *ngIf="showNav" class="bg-card dark:bg-gray-900 print:hidden" [appearance]="'thin'"
    [mode]="'side'" [name]="'mainNavigation'" [navigation]="navigation.compact" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container zuperVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center justify-center h-20 select-none">
            <img width="40" height="40" class="w-10" src="https://app.zuperpro.com/assets/images/logo.png"
                alt="Zuper logo">
        </div>
    </ng-container>
</zuper-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 overflow-hidden">

    <!-- Header -->
    <div
        class="w-full relative flex flex-0 items-center justify-center h-14 px-4 md:px-6 z-49 border-light border-b dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <div class="nav-company-logo h-14 w-25 py-2 select-none" *ngIf="companyLogo || company?.company_logo">
            <img [src]="companyLogo ? companyLogo : company?.company_logo" alt="Company Logo" class="company-logo">
        </div>

        <!-- Components -->
        <div class="flex justify-between items-center pl-2 space-x-0.5 sm:space-x-2 w-full h-full">

            <div id="new-button" class="h-full flex items-center">
                <a mat-stroked-button [matMenuTriggerFor]="navigateToButton"
                    class="flex items-center px-4 py-4 max-h-full h-full border-none shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                    <span class="mr-2 primary-font text-base leading-loose pt-0.5">{{"new" |
                        translate}}</span>
                    <em class="text-xl" class="ti ti-chevron-down "></em>
                </a>
                <mat-menu #navigateToButton="matMenu">
                    <ng-container *ngFor="let data of newButtonData;index as i">
                        <ng-container *ngIf="data.hasModuleAccess && data.hasPermission">
                            <!-- divider incase element is broadcast-->
                            <ng-container *ngIf="data.displayName === 'broadcast'">
                                <div class="flex-grow border-t my-1 border-gray-200"></div>
                            </ng-container>
                            <a class="text-gray-700 text-base primary-font h-10" mat-menu-item
                                (click)="redirectTo(data)">
                                <ng-container *ngIf="data.displayName === 'broadcast'">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        class="icon icon-tabler icon-tabler-speakerphone mr-3" width="18" height="18"
                                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M18 8a3 3 0 0 1 0 6"></path>
                                        <path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"></path>
                                        <path
                                            d="M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8">
                                        </path>
                                    </svg>
                                </ng-container>
                                <span>{{ data.displayKey | translate}}</span>
                            </a>
                        </ng-container>
                    </ng-container>
                </mat-menu>
            </div>
            <div class="flex-1 flex items-center justify-center w-full">
                <div class="max-w-md w-full">
                    <label for="search" class="sr-only">Search</label>
                    <div class="relative" *ngIf="!lightningSearch">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <!-- Heroicon name: solid/search -->
                            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </div>
                        <input type="text" id="search" name="search" [(ngModel)]="search"
                            (click)="openSearchSuggestions()"
                            (keyup.enter)="redirectToSearchModule();showSearchSuggestion = false"
                            class="text-lg block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-indigo-500"
                            placeholder="{{'text.search' | translate}}" autocomplete="off" cdkOverlayOrigin
                            #trigger="cdkOverlayOrigin">
                        <button mat-icon-button *ngIf="search.length"
                            class="mat-focus-indicator min-w-3 min-h-3 min-w 3 h-8 w-8 mat-icon-button mat-button-base absolute inset-y-0 right-0 mr-2"
                            style="margin-top: 0.2rem;" (click)="search = ''; redirectToSearchModule()">
                            <em class="ti ti-x close-mark cursor-pointer text-black text-2xl"></em>
                        </button>
                    </div>
                    <!-- lightning search -->
                    <div class="relative cursor-pointer hover:bg-gray-50" *ngIf="lightningSearch" (click)="openSearch()">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </div>
                        <div class="text-lg block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 text-gray-500">
                            Search
                        </div>
                    </div>
                    <!-- end of lightning search -->
                </div>
            </div>
            <div class="flex justify-end items-center w-0">
                @if(showTimezoneBadge && userPreferredTimezone){
                  <button [@slideDownUp] (click)="showTimezoneDialog()" [title]="userPreferredTimezone" class="flex items-center justify-center focus:border-blue-300 bg-blue-50 border border-blue-100 hover:border-blue-300 transition-all delay-75 rounded-md p-1.5 px-3 mr-3 cursor-pointer space-x-3">
                    <div class="w-2 h-2 rounded-full bg-blue-500"></div>
                    <span class="font-medium text-blue-500 truncate max-w-40">
                      {{userPreferredTimezone}}
                    </span>
                  </button>
                }
                <dialer-button></dialer-button>
                <broadcast (openDrawer)="openBroadcastDrawer($event)"></broadcast>
                <messages></messages>
                <notifications (openBroadcastDrawer)="getBroadcastMessages($event)"></notifications>
                <session-expired-model *ngIf="showModel"></session-expired-model>

                <!-- <button
                    class="lg:hidden"
                    mat-icon-button
                    (click)="quickChat.toggle()">
                    <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
                </button> -->
                <user></user>
            </div>
        </div>
    </div>
    <div>
        <breadcrumb></breadcrumb>
    </div>
    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->

        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Zuper &copy; {{currentYear}}</span>
    </div> -->

</div>

<!-- Broadcast Drawer -->

<zuper-drawer class="broadcast-drawer" [name]="'openBroadcastMessages'" [fixed]="true" [mode]="'over'"
    [position]="'right'" [transparentOverlay]="false">
    <div class="w-full overflow-hidden bg-light">
        <div class="w-full">
            <div class="border-b bg-gray-200 p-5 h-20 w-full">
                <div class="flex flex-row justify-between items-center">
                    <div class="flex">
                        <div class="text-xl font-semibold text-gray-700 primary-font">
                            {{_utilityService.getLocaleValue('broadcast.drawer.header_text')}}
                        </div>
                        <badge *ngIf="broadcastCount" [options]="setListCount()" class="ml-2 primary-font"></badge>
                    </div>
                    <div>
                        <button type="button" mat-icon-button (click)="toggleDrawer('openBroadcastMessages')">
                            <em class="ti ti-x text-xl font-bold text-gray-700"></em>
                        </button>
                    </div>
                </div>
            </div>
            <div class="px-4 overflow-y-auto data-picker-container-body-height pb-6 space-y-4 mt-4"
                *ngIf="myBroadcast && myBroadcast.length > 0">
                <zuper-card class="flex flex-col max-w-140 w-full rounded-lg p-4 space-y-3" *ngFor="let broadcast of myBroadcast">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <div *ngIf="!_utilityService.hasValidProfilePicture(broadcast.created_by['profile_picture'])"
                                class="flex items-center justify-center h-12 w-12 overflow-hidden rounded-full uppercase text-3xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 flex-shrink-0">
                                {{broadcast.created_by?.first_name.slice(0,1)}}
                            </div>
                            <div
                                *ngIf="_utilityService.hasValidProfilePicture(broadcast.created_by['profile_picture']) && broadcast?.created_by?.profile_picture?.length > 0">
                                <img class="h-12 w-12 rounded-full bg-gray-200 object-contain flex items-center justify-center ring-8 ring-white"
                                    src="{{broadcast.created_by['profile_picture']}}" alt="" loading="lazy">
                            </div>
                            <div class="flex flex-col ml-3">
                                <span
                                    class="font-medium leading-none text-black text-base truncate">{{broadcast.created_by.first_name}}
                                    {{broadcast.created_by?.last_name || ''}}</span>
                                <span class="text-md leading-none mt-2 text-gray-600 cursor-pointer"
                                    title="{{broadcast.created_at | datetime}}"><em
                                        class="ti ti-clock-hour-8 mr-1"></em>{{broadcast.created_at | dateAgo}}</span>
                            </div>
                        </div>
                        <div>
                            <mat-icon *ngIf="broadcast.broadcast_type?.important"
                                [svgIcon]="'heroicons_outline:exclamation-circle'" class="text-red-700"
                                title="{{_utilityService.getLocaleValue('important','Important')}}"></mat-icon>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <p class="text-base text-black break-all line-clamp-2" title="{{broadcast?.broadcast_content}}">
                            {{broadcast?.broadcast_content}}</p>
                        <a *ngIf="broadcast.broadcast_action?.type === 'EXTERNAL_LINK'"
                            class="text-base text-color-copy break-all line-clamp-2 flex space-x-1"
                            href="{{broadcast.broadcast_action.redirect_to}}"
                            target="_blank">
                            <i class="ti ti-link text-2xl text-color-copy"></i>
                            <span class="break-all line-clamp-2" title="{{broadcast?.broadcast_action?.redirect_to}}">{{broadcast?.broadcast_action?.redirect_to}}</span>
                        </a>
                        <!-- IMAGE -->
                        <div class="border border-gray-200 rounded-lg p-2" *ngIf="broadcast?.broadcast_image" >
                            <img src="{{broadcast?.broadcast_image}}"
                            (click)="openLightGallery(broadcast)"
                            class="cursor-zoom-in mb-3 w-full h-32 rounded-md overflow-hidden flex-shrink-0 object-contain"
                            [ngClass]="{'mb-3': (!broadcast.broadcast_type?.important || broadcast.broadcast_action?.type === 'EXTERNAL_LINK')}"
                            alt="Broadcast Image">
                        </div>
                    </div>
                </zuper-card>
            </div>
            <!-- No Broadcast -->
            <div *ngIf="!myBroadcast || myBroadcast.length===0"
                class="data-picker-container-body-height flex items-center">
                <div
                    class="flex flex-col flex-auto items-center md:justify-center sm:justify-start py-12 px-8 m-5 rounded-xl">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                        <mat-icon class="text-primary-500-700" [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">
                        {{_utilityService.getLocaleValue('broadcast.no_broadcast', 'No Broadcast')}}</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">
                        {{_utilityService.getLocaleValue('broadcast.when_you_have_broadcast_they_will_appear_here',
                        'When you have broadcasts, they will appear here.')}}</div>
                </div>
            </div>
        </div>
    </div>
</zuper-drawer>

<!-- End of Broadcast Drawer -->

<div [hidden]="true" style="width: 70%;" class="broadcast-light-gallery">
    <lightgallery [settings]="lightGallerySettings" [onInit]="lightOnInit">
        <a href=""></a>
    </lightgallery>
</div>

<ng-template *ngIf="!lightningSearch" id="searchOverlay" cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showSearchSuggestion" (overlayOutsideClick)="showSearchSuggestion = false">
    <div class="border shadow bg-white rounded-lg p-3 px-4 m-0 mt-0.5" style="width: 28rem !important">
        <div class="flex items-center justify-between mb-2">
            <h5 class="text-secondary my-1">{{'overall_search.recently_viewed' | translate}}</h5>
            <p class="text-red-400 cursor-pointer font-semibold text-medium" (click)="clearRecentActivity()">
                {{'overall_search.recently_viewed.clear' | translate}}</p>
        </div>
        <ul>
            <li *ngFor="let search of previouslySearchedValues"
                class="py-2 flex items-center justify-between space-x-4">
                <!-- Icon -->
                <div class="flex items-center">
                    <ng-container *ngIf="search.module">
                        <div
                            class="flex relative flex-shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-lg bg-primary-50 dark:bg-primary">
                            <em [ngClass]="getIconClass(search.module)"
                                class="text-2xl font-medium search-icon-color"></em>
                        </div>
                    </ng-container>
                    <span class="line-clamp-2 break-words">{{search.title}}</span>
                </div>
                <a class="cursor-pointer search-icon-color font-medium" [routerLink]="getRouterLink(search)"
                    (click)="showSearchSuggestion = false">{{'overall_search.recently_viewed.view' | translate}}</a>
            </li>
        </ul>
    </div>
</ng-template>